import React from 'react';

/**
 * The import is running: every row's controls wait (its Edit, its note's Fix
 * and its Exclude / Include). The table and
 * the card list provide it around their rows instead of handing it to each
 * row, so the import's start and its answer re-render only the buttons on
 * screen. As a column or list dependency it rebuilt the whole collection
 * twice per import: about 1.4 s of main thread each time for 2,000 rows under
 * the development build, 0.25 s in production (bos-app#199).
 */
export const RowExclusionLockContext = React.createContext(false);
